import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Auth } from '../../../../../decorators/auth.decorator';
import { Subscribe } from '../../../../../decorators/subscribe.decorator';
import { ShareService } from '../../../../../services/share.service';

@Component({
  selector: 'app-search-modal-favorites-navbar-top',
  templateUrl: './search-modal-favorites-navbar-top.component.html',
  styleUrls: ['../../../../navbar/navbar.shared.scss']
})
export class SearchModalFavoritesNavbarTopComponent implements OnInit {
  @Input() title: string;
  @Input() eatenCount: number;

  @Output() titleClick = new EventEmitter<boolean>();

  constructor(
    private shareService: ShareService,
  ) {
  }

  ngOnInit() {
  }

  @Auth()
  @Subscribe()
  openMembershipModal() {}

  onClickShare() {
    this.shareService.shareUrl(location.href);
  }
}
